import {useState} from "react";
// import {Link} from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import {InsertForm} from "./insertForm";
import {SearchForm} from "./searchForm";

/*
 * Common functions for Suspension forms
 */

export const validLengthAndOnlyDigits = (value, length) => {
	return ( new RegExp(`^\\d{${length}}$`).test(value) );
}

export const trimValue = (value) => value ? value.trim() : "";


const SuspendedForm = () => {
	const [activeTab, setActiveTab] = useState("insert");

	const handleTabChange = (tab) => {
		setActiveTab(tab);
	};

	const getBody = () => {
		return (
			<div>
				<h1 style={{ textAlign: "center" }}>Suspended χρήστες</h1>
				{/* Tabs */}
				<div style={{
					display: "flex",
					justifyContent: "center",
					margin: "20px 0 20px 0",
					borderBottom: "2px solid #ddd",

				}}>
					<button
						onClick={() => handleTabChange("insert")}
						style={{
							flex: 1,
							padding: "15px",
							textAlign: "center",
							fontSize: "18px",
							fontWeight: "bold",
							cursor: "pointer",
							border: "none",
							transition: "all 0.3s ease",
							borderBottom: activeTab === "insert" ? "3px solid #0056b3" : "none",
							backgroundColor: activeTab === "insert" ? "#003476" : "#f1f1f1",
							color: activeTab === "insert" ? "white" : "#333",
						}}
					>
						Φόρμα Προσθήκης
					</button>
					<button
						onClick={() => handleTabChange("search")}
						style={{
							flex: 1,
							padding: "15px",
							textAlign: "center",
							fontSize: "18px",
							fontWeight: "bold",
							cursor: "pointer",
							border: "none",
							transition: "all 0.3s ease",
							borderBottom: activeTab === "search" ? "3px solid #0056b3" : "none",
							backgroundColor: activeTab === "search" ? "#003476" : "#f1f1f1",
							color: activeTab === "search" ? "white" : "#333",
						}}
					>
						Φόρμα Αναζήτησης
					</button>
				</div>
				{/* Forms */}
				{activeTab === "insert" && <InsertForm />}
				{activeTab === "search" && <SearchForm />}
			</div>
		);
	};

	return (
		<MainContainer>
			<div className="col-lg-12">
				{/* <Link to="/ticket-office/choose-user" className="btn btn-back mb-4" tabIndex="0">
					<svg className="govgr-svg-icon--caret govgr-svg-icon" focusable="false" viewBox="0 0 24 24"
						aria-hidden="true">
						<path d="M18,22V2L6,12L18,22z"></path>
					</svg>
					Πίσω
				</Link> */}
				{getBody()}
			</div>
		</MainContainer>
	);
};

export const formStyle = {
	background: "white",
	maxWidth: "700px",
	margin: "0 auto",
	padding: "20px",
	borderRadius: "8px",
	boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)"
}

export default SuspendedForm;
